import React, { FC, useContext, useEffect, useState } from 'react';

import { FormControlLabel, Popover, Radio, RadioGroup } from '@material-ui/core';
import styled from 'styled-components';

import { GlobalContext } from '../../store';
import { ITeam } from '../../store/admin/eventTeams/store';
import { IAdminFlight } from '../../store/admin/eventFlights/store';

import { ArrowUp } from '../ArrowUp/ArrowUp';
import { px } from '../../contrib/ui';
import { useRouteInfoState } from '../RouteInfo/Context/RouteInfo.context';
import { useGetAdminEvent } from '../../contrib/Hooks/useGetAdminEvent';

interface IProps {
  team: ITeam;
}

export const ChangeTeamFlight: FC<IProps> = props => {
  const { team } = props;

  const {
    actions: {
      adminEventTeams: { update: updateTeam },
      notifications: { pushError, pushSuccess }
    }
  } = useContext(GlobalContext);
  const { clubId, eventId } = useRouteInfoState();

  const [anchorMenu, setAnchorMenu] = useState<any>(null);
  const [flights, setFlights] = useState<IAdminFlight[]>([]);

  const event = useGetAdminEvent(eventId);

  useEffect(() => {
    if (event) {
      setFlights(event.flights.filter(flight => flight.category === 't'));
    }
  }, [event]);

  const open = (evnt: any) => {
    setAnchorMenu(evnt.currentTarget);
  };

  const close = () => {
    setAnchorMenu(null);
  };

  const handleChange = async (evnt: any) => {
    try {
      await updateTeam(clubId, eventId, team.id, { flight: Number(evnt.target.value) });

      await pushSuccess('The flight was assigned');
    } catch (error) {
      await pushError('The flight could not be assigned');
    } finally {
      close();
    }
  };

  return (
    <>
      <ArrowUp onClick={open} />

      <Popover
        className="flight-change-menu staff-scope"
        classes={{ paper: 'change-menu-paper' }}
        id={`menu-popper-${team.id}`}
        open={!!anchorMenu}
        anchorEl={anchorMenu}
        onClose={close}
        anchorOrigin={{
          horizontal: 'center',
          vertical: 'bottom'
        }}
        transformOrigin={{
          horizontal: 'center',
          vertical: 'top'
        }}
      >
        <PopoverContainer>
          <div className="flight-change-menu-content">
            <RadioGroup
              aria-label="gender"
              name="gender2"
              value={String(team.flight)}
              onChange={handleChange}
            >
              {flights.map(({ id: flightId, name: flightName }) => (
                <FormControlLabel
                  key={`flight-option-${team.id}-${flightId}`}
                  value={String(flightId)}
                  className="radio-flight-item"
                  classes={{ label: 'radio-label' }}
                  control={
                    <Radio
                      color="primary"
                      className="radio-flight"
                      classes={{ checked: 'radio-checked' }}
                    />
                  }
                  label={flightName}
                  labelPlacement="end"
                />
              ))}
            </RadioGroup>
          </div>
        </PopoverContainer>
      </Popover>
    </>
  );
};

const PopoverContainer = styled.div`
  padding: ${px(5)} ${px(10)};
`;
